import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id FEA3388A-F985-482C-8CE0-0B4ABCD31691
 * name cup-outline
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cup-outline.svg
 * tags
 * - Food / Drink 
 */
export const CupOutlineIcon = createSvgIcon(<><path d="M3 2L5 20.23C5.13 21.23 5.97 22 7 22H17C18 22 18.87 21.23 19 20.23L21 2H3M5.22 4H18.78L17 20H7L5.22 4Z" /></>, 'CupOutlineIcon');
export default CupOutlineIcon